import { render, staticRenderFns } from "./TabButtons.vue?vue&type=template&id=0d18d40c&scoped=true&"
import script from "./TabButtons.vue?vue&type=script&lang=js&"
export * from "./TabButtons.vue?vue&type=script&lang=js&"
import style0 from "./TabButtons.vue?vue&type=style&index=0&id=0d18d40c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d18d40c",
  null
  
)

export default component.exports